import React, {useState, useEffect} from 'react';
import {Toast, Modal} from 'antd-mobile-v2';
import BackHeader from '@comp/BackHeader';
import ImgSuc from '@/assets/icons/suc.png';
import {storage, locationTo} from '@utils/tools';
import {receiveCoupon} from '@/store/api/coupon';

import './index.less';
import queryString from 'query-string';
import {COMMENT_KEY} from '@views/Comment/index';

export default function (props) {
  let {user_id} = queryString.parse(props.location.search);
  const [list, setList] = useState([]);
  const [cidx, setCidx] = useState(-1);
  const [isMP, setMP] = useState(storage.get(COMMENT_KEY, 'session') === 'mp');

  useEffect(() => {
    setList(storage.get('commentCoupons') || []);
  }, []);

  const onGetCoupon = async (coupon, idx) => {
    const {status, message} = await receiveCoupon({
      coupon_id: '1',
      group_id: coupon.group_id,
      user_id,
    });
    if (status === '0') {
      setCidx(idx);
      Modal.alert('成功', `${coupon.coupon_name}已领取成功！`, [
        {
          text: '确定',
          onPress: () => {
            storage.remove('commentCoupons');
            if (isMP) {
              let wx = window.wx || {};
              wx.miniProgram.switchTab({
                url: `/pages/user/index`, //跳转到小程序个人页
              });
            } else {
              locationTo(location.origin + '/usercenter');
            }
          },
        },
      ]);
      // Toast.success(`${coupon.coupon_name}已领取成功！`, 1.5, () => {});
    } else {
      Toast.fail(message);
    }
  };

  return (
    <section className="cmt-suc">
      {!isMP && <BackHeader title={'评价成功'} />}
      <div className="main">
        <div className="suc">
          <img src={ImgSuc} alt="" />
        </div>
        {list.length ? (
          <div className="coupons-wrapper">
            <div className="tit">领取优惠券（三选一）</div>
            <div className="coupons">
              {list.map((item, idx) => (
                <div className="coupon" key={idx}>
                  <div className="coupon-main">
                    <div className="coupon-tag">优惠券</div>
                    <div className="coupon-txt">{item.coupon_name}</div>
                  </div>
                  <div className="coupon-divider" />
                  <div className="coupon-foot">
                    <div
                      className={`coupon-btn ${idx === cidx ? 'disabled' : ''}`}
                      onClick={() => onGetCoupon(item, idx)}
                    >
                      点击领取
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
}
